<template>
    <Modal ref="Modal" :title="$t('labels.client')">
        <div class="modal-body">
            <FormGroup :label="$t('labels.name')">
                <Input v-model="name"/>
            </FormGroup>
            <FormGroup :label="$t('labels.email')">
                <Input v-model="email"/>
            </FormGroup>
            <FormGroup :label="$t('labels.phone')">
                <Input v-model="phone"/>
            </FormGroup>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <Button color="indigo" @click="create">
                <span>{{ $t('buttons.create') }}</span>
            </Button>
        </div>
    </Modal>
</template>
<script>
import Modal from "../../../../../components/new/modal/AppModal.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import Button from "../../../../../components/new/button/AppButton.vue";

import { httpClient } from "../../../../../services/HttpClient";
import MessageNotificator from "../../../../../services/MessageNotificator";

export default {
    name: "CreateOrderStatusModal",
    components: {
        Modal, FormGroup, Input, Button
    },
    emits: ['client:created'],
    data() {
        return {
            name: null,
            email: null,
            phone: ""
        }
    },
    methods: {
        show() {
            this.$refs.Modal.show()
        },
        create() {
            httpClient.post(`/projects/${this.$route.params.projectUuid}/crm/clients`, {
                name: this.name,
                email: this.email,
                phone: this.phone
            }).then((response) => {
                this.$emit('client:created', response.data.data)
                this.$refs.Modal.hide()
                new MessageNotificator().success(this.$t("alerts.success"))
            })
        }
    }
}
</script>